var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcPreviousConferenceOn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 34,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic-previous-conference-on_svg__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 17,
  r: 17,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic-previous-conference-on_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#577CD3",
  d: "M9.5 13a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M24.03 10h-10.2a1.5 1.5 0 0 0 0 3h10.2a1.5 1.5 0 0 0 0-3"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5168AA",
  d: "M9.5 18.29a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M24.03 15.29h-10.2a1.5 1.5 0 0 0 0 3h10.2a1.5 1.5 0 1 0 0-3"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#577CD3",
  d: "M9.5 23.57a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M24.03 20.57h-10.2a1.5 1.5 0 0 0 0 3h10.2a1.5 1.5 0 1 0 0-3"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-previous-conference-on_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h34v34H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-previous-conference-on_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M8 10h17.52v13.57H8z"
})))));
export default SvgIcPreviousConferenceOn;